module.exports = __webpack_public_path__ + "static/ojini-7926197865eb7269a5a3cca7262fed41.png";